export type DentalPuenteBranch = {
  id: 'teodomiro' | 'gigantera';
  name: string;
  shortName: string;
  badge: string;
  status: string;
  address: string;
  phone: string;
  phoneDisplay: string;
  whatsappText: string;
  schedule: string;
  note: string;
  coordinates: {
    lat: number;
    lng: number;
    zoom: number;
  };
};

export const branches: DentalPuenteBranch[] = [
  {
    id: 'teodomiro',
    name: 'DentalPuente Teodomiro Manzano',
    shortName: 'Teodomiro Manzano',
    badge: 'Sucursal principal',
    status: 'Atención con previa cita',
    address: 'Teodomiro Manzano 4365, Guadalajara, Jal.',
    phone: '523334758191',
    phoneDisplay: '33 34 75 81 91',
    whatsappText: 'Hola DentalPuente, me gustaría agendar una cita en la sucursal Teodomiro Manzano.',
    schedule: 'Lun - Sab · 10:00 am - 7:00 pm',
    note: 'Ideal para valoración, seguimiento, limpieza dental, estética y ortodoncia.',
    coordinates: {
      lat: 20.616824616560514,
      lng: -103.3751566,
      zoom: 18,
    },
  },
  {
    id: 'gigantera',
    name: 'DentalPuente Plaza La Gigantera',
    shortName: 'Plaza La Gigantera',
    badge: 'Ya abrimos',
    status: 'Únicamente con cita agendada',
    address: 'Hda. de La Calerilla 1000, La Gigantera, 45601 San Pedro Tlaquepaque, Jal.',
    phone: '523332548449',
    phoneDisplay: '33 32 54 84 49',
    whatsappText: 'Hola DentalPuente, me gustaría agendar una cita en Plaza La Gigantera.',
    schedule: 'Atención por cita · Agenda antes de asistir',
    note: 'Nueva sucursal abierta. Por ahora atendemos en local únicamente con cita confirmada.',
    coordinates: {
      lat: 20.586163,
      lng: -103.400582,
      zoom: 18,
    },
  },
];

export const teodomiroBranch = branches.find((branch) => branch.id === 'teodomiro') as DentalPuenteBranch;
export const giganteraBranch = branches.find((branch) => branch.id === 'gigantera') as DentalPuenteBranch;

export const getWhatsappUrl = (branch: DentalPuenteBranch, extraText?: string) => {
  const message = extraText || branch.whatsappText;
  return `https://api.whatsapp.com/send?phone=${branch.phone}&text=${encodeURIComponent(message)}`;
};

export const getTelUrl = (branch: DentalPuenteBranch) => `tel:+${branch.phone}`;

export const getOpenStreetMapUrl = (branch: DentalPuenteBranch) => {
  const { lat, lng, zoom } = branch.coordinates;
  return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;
};
